import { withInstall } from '../../utils/vue/install'
import View from './src/import-view.vue'

export const ImportView = withInstall(View)

export * from './src/import-view'
